module.exports = __webpack_public_path__ + "static/comcard-90c0a38d1f0345cd6986e8a3154d2249.svg";